import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {setAuthenticated, setCurrentUser, setLoading, setUserInfo} from "../../redux/userSlice";

// set unauthorized and let the framework handle the rest
const Logout = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setAuthenticated(false));
        dispatch(setCurrentUser({}));
        dispatch(setLoading(false));
        dispatch(setUserInfo({}));
    }, [dispatch]);

    return (
        <>
        </>
    );
}

export default Logout;